import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { HospitalLicenseService } from "app/services/license/hospital/hospital-license.service";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class HospitalLicenseValidator implements AsyncValidator {
  constructor(private service: HospitalLicenseService){}

  validate(
    control: AbstractControl
  ): Observable< ValidationErrors | null > {
    return this.service.checkIfLicenseExists(control.value).pipe(
      map(valid => (
        !valid ? { invalidLicense: true} : null
        )),
      catchError(() => of(null))
    )
  }
}
